import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserVacationV2 } from '@wilson/absences';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { stringify } from 'qs';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VacationManagementV2Service {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'users';

  /**
   * Fetches vacation status for users.
   * @param queryParams - Query parameters including year and optional userIds for filtering
   * @param queryParams.where.year - The year to fetch vacation data for
   * @param queryParams.where.userIds - Optional array of user IDs to filter results
   * @returns Observable of vacation status for users
   * @example
   * // Fetch all users for a year
   * getUsersVacationStatus({ where: { year: 2025 } })
   *
   * // Fetch specific users for a year
   * getUsersVacationStatus({ where: { year: 2025, userIds: ['id1', 'id2'] } })
   */
  public getUsersVacationStatus(queryParams: {
    where: { year: number; userIds?: string[] };
  }): Observable<UserVacationV2[]> {
    const params = stringify(queryParams, {
      arrayFormat: 'brackets',
    });

    return this.http
      .get<
        UserVacationV2[]
      >(`${this.config.host}/${this.path}/vacation/status?${params}`)
      .pipe(map((data) => data.map((d) => new UserVacationV2(d))));
  }

  updateUsersVacationStatus(vacation: UserVacationV2) {
    return this.http.patch<UserVacationV2>(
      `${this.config.host}/user-vacations/${vacation.userId}`,
      vacation,
    );
  }
}
